<template>
  <div>
    <div class="pa-4 d-flex justify-space-between align-center">
      <div>
        <Breadcrumbs headline="Chuyên cần" :link="[{ text: 'Chuyên cần', href: '../attendances' }]" />
      </div>
    </div>
    <v-tabs class="mx-md-4" v-model="tab" active-class="tab-active" background-color="transparent">
      <v-tab v-for="item in getTabs" :key="item" class="tab-default">
        {{ item }}
      </v-tab>
    </v-tabs>

    <v-card outlined class="mx-md-4 elevation-0">
      <v-tabs-items v-model="tab" v-if="getTabs.length > 0">
        <v-tab-item v-if="getTabs.includes('Điểm danh')" :key="1">
          <Attendances />
        </v-tab-item>
        <v-tab-item v-if="getTabs.includes('Chuyên cần')" :key="2">
          <!-- <diligences /> -->
          <DiligenceCheck />
        </v-tab-item>
        <v-tab-item v-if="getTabs.includes('Thống kê')" :key="3">
          <DiligenceStudentReport />
        </v-tab-item>
      </v-tabs-items>
    </v-card>
  </div>
</template>

<script>
import Breadcrumbs from '@/components/layout/Breadcrumbs.vue'
import Attendances from '@/views/attendance/Attendances.vue'
import DiligenceCheck from '../diligence/DiligenceCheck.vue'
import DiligenceStudentReport from '../diligence/DiligenceStudentReport.vue'
// import Diligences from '../diligence/Diligences.vue'

export default {
  components: {
    Breadcrumbs,
    Attendances,
    DiligenceCheck,
    DiligenceStudentReport,
    // Diligences
  },
  data() {
    return {
      tab: null,
    }
  },
  computed: {
    getTabs() {
      const tabs = []
      if (this.$auth.policies['view-attendance-list']) {
        tabs.push('Điểm danh')
      }
      if (this.$auth.policies['view-diligence-list']) {
        tabs.push('Chuyên cần')
      }
      if (this.$auth.policies['view-diligence-list']) {
        tabs.push('Thống kê')
      }
      return tabs
    },
  },
  created() {
    if (this.$route.query.diligence) {
      this.tab = 1
    } else if (this.getTabs.length > 0) {
      this.tab = 0
    }
  },
}
</script>
